module.exports = "/_next/static/images/6c25c4ef23c72be39210ed9a58c184c4-rates-icon.svg";